



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETALLPLANSGET
// GETALLPLANSGET
const GETALLPLANSGET= createAsyncThunk(
  "getAllPlansGet/getAllPlansGet",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPlansGetSlice = createSlice({
  name: "getAllPlansGetSlice",
  initialState: {
    getAllPlansGet: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPlansGet: (state) => {
        state.getAllPlansGet.loading = false
        state.getAllPlansGet.error = false
        state.getAllPlansGet.data = []
        state.getAllPlansGet.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPLANSGET.fulfilled, (state, action) => {
      state.getAllPlansGet = {
        ...state.getAllPlansGet,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSGET.pending, (state, action) => {
      state.getAllPlansGet = {
        ...state.getAllPlansGet,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSGET.rejected, (state, action) => {
      state.getAllPlansGet = {
        ...state.getAllPlansGet,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPlansGetAction = {
    GETALLPLANSGET,
};

export { getAllPlansGetAction };
export default getAllPlansGetSlice.reducer;
export const {setInitialStateOfgetAllPlansGet} = getAllPlansGetSlice.actions